import React, {useState, useEffect} from "react"

import buService from "@irati/billing/services/bu"
import authentication from "@irati/auth"
import userService from "@irati/identity/services/users"
import adminTracking from "@irati-tracking/admin"
import {hangPromise} from "@irati/utils/promise"
import FormattedMessage from "@irati/utils/lang"
import {UsersForBusinessVariables} from "@irati/identity/apollo/query/UsersForBusiness"
import Loading from "@irati/ui/src/Loading"
import Flex from "@irati/ui/src/Flex"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {H3, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Close from "@irati/ui/src/Close"
import theme from "@irati/ui/src/global/theme"

import  {Banner, GlobalLicensesImg} from "./styled"
import {ADD_PEOPLE_SINGLE} from "../../routes/routeConfig"

interface Props {}

const UnusedLicensesBanner: React.FC<Props> = () => {
  const [load, setLoad] = useState<Promise<any> | null>(hangPromise())
  const [show, setShow] = useState<boolean>(false)
  const [licenses, setLicenses] = useState<number>(0)
  const [enabledUsers, setEnabledUsers] = useState<number>(0)

  const handleClose = () => {
    setShow(false)
  }

  const handleButton = () => {
    adminTracking.unusedLicensesClick()
  }

  const getData = (businessId: string, params: UsersForBusinessVariables) => {
    return Promise.all([
      buService.getSeatsCount({businessId}),
      userService.getUsersForBusiness(params)
    ]).then((response) => {
      const [dataSeats, userList] = response
      if (dataSeats.count && userList.total) {
        setLicenses(dataSeats.count)
        setEnabledUsers(userList.total)
        setShow(true)
      }
    }).catch(() => {
      setShow(false)
    })
  }

  useEffect(() => {
    const businessId = authentication.business().uuid
    const params: UsersForBusinessVariables = {
      businessId,
      enabled: true,
      totalOnly: true
    }
    const loadData = getData(businessId, params)
    setLoad(loadData)
  }, [])

  return (
    <Loading load={load}>
      {show && (licenses > enabledUsers) &&
        <Banner>
          <Close top={theme.spacing.two} right={theme.spacing.two} onClick={handleClose} />
          <Flex justifyContent="space-between" width="100%">
            <Flex gap={theme.spacing.three}>
              <GlobalLicensesImg />
              <Flex direction="column" justifyContent="center" gap={theme.spacing.one}>
                <H3>
                  <FormattedMessage id="admin.manageUsers.unusedLicenses.title" />
                </H3>
                <Body>
                  <FormattedMessage id="admin.manageUsers.unusedLicenses.subTitle" />
                </Body>
              </Flex>
            </Flex>
            <Flex alignItems="center" gap={theme.spacing.one}>
              <ButtonRouterLink primary to={ADD_PEOPLE_SINGLE} onClick={handleButton}>
                <FormattedMessage id="admin.manageUsers.unusedLicenses.button.addUsers" />
              </ButtonRouterLink>
              <Button onClick={handleClose}>
                <FormattedMessage id="admin.manageUsers.unusedLicenses.button.notNow" />
              </Button>
            </Flex>
          </Flex>
        </Banner>
      }
    </Loading>
  )
}

export default UnusedLicensesBanner
